"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var methods = {
  GET_LINK: '3id_getLink',
  LINK_MANAGEMENT_KEY: '3id_linkManagementKey',
  AUTHENTICATE: '3id_authenticate',
  IS_AUTHENTICATED: '3id_isAuthenticated',
  SIGN_CLAIM: '3id_signClaim',
  ENCRYPT: '3id_encrypt',
  DECRYPT: '3id_decrypt',
  HASH_ENTRY_KEY: '3id_hashEntryKey',
  NEW_AUTH_METHOD_POLL: '3id_newAuthMethodPoll',
  NEW_LINK_POLL: '3id_newLinkPoll'
};

var callbackOrThrow = function callbackOrThrow(callback, errMsg) {
  if (callback) {
    callback(errMsg);
  } else {
    throw errMsg instanceof Error ? errMsg : new Error(errMsg);
  }
};

var ThreeIdProvider =
/*#__PURE__*/
function () {
  function ThreeIdProvider(idWallet) {
    var _this = this;

    (0, _classCallCheck2["default"])(this, ThreeIdProvider);
    this.is3idProvider = true;
    this._idWallet = idWallet;
    this._newAuthMethods = [];
    this._newLinks = [];

    this._idWallet.events.on('new-auth-method', function (authBlob) {
      _this._newAuthMethods.push(authBlob);
    });

    this._idWallet.events.on('new-link-proof', function (linkProof) {
      _this._newLinks.push(linkProof);
    });
  }

  (0, _createClass2["default"])(ThreeIdProvider, [{
    key: "send",
    value: function send(req, origin, callback) {
      var result, response;
      return _regenerator["default"].async(function send$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (typeof origin === 'function') {
                callback = origin;
                origin = null;
              }

              _context.prev = 1;
              _context.t0 = req.method;
              _context.next = _context.t0 === methods.GET_LINK ? 5 : _context.t0 === methods.LINK_MANAGEMENT_KEY ? 9 : _context.t0 === methods.AUTHENTICATE ? 13 : _context.t0 === methods.IS_AUTHENTICATED ? 17 : _context.t0 === methods.SIGN_CLAIM ? 21 : _context.t0 === methods.ENCRYPT ? 25 : _context.t0 === methods.DECRYPT ? 29 : _context.t0 === methods.HASH_ENTRY_KEY ? 33 : _context.t0 === methods.NEW_AUTH_METHOD_POLL ? 37 : _context.t0 === methods.NEW_LINK_POLL ? 40 : 43;
              break;

            case 5:
              _context.next = 7;
              return _regenerator["default"].awrap(this._idWallet.getLink());

            case 7:
              result = _context.sent.toLowerCase();
              return _context.abrupt("break", 45);

            case 9:
              _context.next = 11;
              return _regenerator["default"].awrap(this._idWallet.linkManagementKey());

            case 11:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 13:
              _context.next = 15;
              return _regenerator["default"].awrap(this._idWallet.authenticate(req.params.spaces, {
                authData: req.params.authData,
                address: req.params.address
              }, origin));

            case 15:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 17:
              _context.next = 19;
              return _regenerator["default"].awrap(this._idWallet.isAuthenticated(req.params.spaces, origin));

            case 19:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 21:
              _context.next = 23;
              return _regenerator["default"].awrap(this._idWallet.signClaim(req.params.payload, {
                DID: req.params.did,
                space: req.params.space,
                expiresIn: req.params.expiresIn
              }));

            case 23:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 25:
              _context.next = 27;
              return _regenerator["default"].awrap(this._idWallet.encrypt(req.params.message, req.params.space, {
                blockSize: req.params.blockSize,
                to: req.params.to
              }));

            case 27:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 29:
              _context.next = 31;
              return _regenerator["default"].awrap(this._idWallet.decrypt({
                ciphertext: req.params.ciphertext,
                ephemeralFrom: req.params.ephemeralFrom,
                nonce: req.params.nonce
              }, req.params.space, req.params.buffer));

            case 31:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 33:
              _context.next = 35;
              return _regenerator["default"].awrap(this._idWallet.hashDBKey(req.params.key, req.params.space));

            case 35:
              result = _context.sent;
              return _context.abrupt("break", 45);

            case 37:
              result = (0, _toConsumableArray2["default"])(this._newAuthMethods);
              this._newAuthMethods = [];
              return _context.abrupt("break", 45);

            case 40:
              result = (0, _toConsumableArray2["default"])(this._newLinks);
              this._newLinks = [];
              return _context.abrupt("break", 45);

            case 43:
              callbackOrThrow(callback, "Unsupported method: ".concat(req.method));
              return _context.abrupt("return");

            case 45:
              _context.next = 51;
              break;

            case 47:
              _context.prev = 47;
              _context.t1 = _context["catch"](1);
              callbackOrThrow(callback, _context.t1);
              return _context.abrupt("return");

            case 51:
              response = {
                'id': req.id,
                'json-rpc': '2.0',
                result: result
              };
              if (callback) callback(null, response);
              return _context.abrupt("return", response);

            case 54:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[1, 47]]);
    }
  }]);
  return ThreeIdProvider;
}();

module.exports = ThreeIdProvider;